<section class="calendar-integrations" aria-label="Calendar integrations">
  <header class="calendar-integrations__header">
    <div>
      <p class="calendar-integrations__eyebrow">Calendar</p>
      <h2>Sync</h2>
      <p>Connect external calendars (structure ready; OAuth flow can be added next).</p>
    </div>

    <button type="button" mat-icon-button aria-label="Close calendar integrations dialog" (click)="close()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <section class="calendar-integrations__list" aria-label="Connected integrations">
    @if (integrations().length === 0) {
      <p class="calendar-integrations__empty">No integrations connected.</p>
    } @else {
      @for (item of integrations(); track item.id) {
        <div class="calendar-integrations__item">
          <div>
            <strong>{{ item.provider | titlecase }}</strong>
            <p class="calendar-integrations__meta">
              {{ item.status || 'unknown' }} @if (item.account_email) { • {{ item.account_email }} }
            </p>
          </div>
          <button type="button" mat-stroked-button color="primary" (click)="disconnect(item.provider)">Disconnect</button>
        </div>
      }
    }
  </section>

  <form class="calendar-integrations__form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <h3>Manual connect</h3>

    <div class="calendar-integrations__row">
      <mat-form-field appearance="outline">
        <mat-label>Provider</mat-label>
        <mat-select formControlName="provider">
          <mat-option value="google">Google Calendar</mat-option>
          <mat-option value="outlook">Outlook Calendar</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Calendar ID</mat-label>
        <input matInput type="text" formControlName="external_calendar_id" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Account email (optional)</mat-label>
      <input matInput type="email" formControlName="account_email" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Access token</mat-label>
      <textarea matInput rows="3" formControlName="access_token"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Refresh token (optional)</mat-label>
      <textarea matInput rows="2" formControlName="refresh_token"></textarea>
    </mat-form-field>

    <div class="calendar-integrations__row">
      <mat-form-field appearance="outline">
        <mat-label>Expires at (RFC3339, optional)</mat-label>
        <input matInput type="text" formControlName="expires_at" placeholder="2026-03-26T12:00:00Z" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>External user id (optional)</mat-label>
        <input matInput type="text" formControlName="external_user_id" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Scopes (comma-separated, optional)</mat-label>
      <input matInput type="text" formControlName="scopes" />
    </mat-form-field>

    <div class="calendar-integrations__actions">
      <button type="button" mat-stroked-button color="primary" (click)="close()">Close</button>
      <button type="submit" mat-flat-button color="primary" [disabled]="loading()">Save</button>
    </div>
  </form>
</section>

